import {createContext, useContext} from "react";

export const ArchiveContext = createContext();
export const useArchiveContext = () => useContext(ArchiveContext);